import React, { useEffect, useState } from 'react';

/**
 * True once the element has come within a screenful of the viewport, and it stays
 * true — the observer is there to delay the first load, not to unload anything.
 * Without IntersectionObserver the content simply loads as it used to.
 */
export const useInView = (ref: React.RefObject<Element>): boolean => {
  const [inView, setInView] = useState(typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    const node = ref.current;
    if (inView || !node) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) setInView(true);
      },
      { rootMargin: '200px' },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, inView]);

  return inView;
};
